import IMG1 from '../../assets/portfolio1.jpg'
import Gesture from '../../assets/gesture-small.jpg'
import UserOs from '../../assets/UserOs-small.jpg'
import Mart from '../../assets/mart-small.jpg'
import ItinearyMin from '../../assets/itinerary-small.jpg'
import CustomerCredit from '../../assets/credit-small.jpg'


export const PortfolioData=[{
    img:<img src={Gesture} alt="GestureRecognition"/>,
    title:'Gesture Recognition',
    link1:"/GestureRecognition",
    link2:"https://github.com/Anmol23oct/Gesture-Recognition-using--SNN"

},
{
    img:<img src={UserOs} alt="UserOs"/>,
    title:'User Operating System',
    link1:"/UserOs",
    link2:"https://github.com/Anmol23oct/User-Operating-System-Core"
},
{
    img:<img src={Mart} alt="martIntegration"/>,
    title:'Mart Intergration',
    link1:"/Mart",
    link2:"https://github.com/Anmol23oct/Mart-Integration"
},
{
    img:<img src={ItinearyMin} alt="ItineraryMinimization"/>,
    title:'Itinerary Cost Minimization',
    link1:"/ItineraryMin",
    link2:"https://github.com/Anmol23oct/Itineary-Cost-Minimization"
},
{
    img:<img src={CustomerCredit} alt="CreditAnalysis"/>,
    title:'Customer Credit Analysis',
    link1:"/CreditAnalysis",
    link2:"https://github.com/Anmol23oct/Data-Analysis-with-Neo4j-and-Mongo-Db"
}

]